import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { PropertyMediaImagesWithStore } from '../../../property-media/property-media-images';
import { PropertyMediaVideosWithStore } from '../../../property-media/property-media-video';

export const PropertyDetailMediaView = () => {
  return (
    <Container fluid>
      <Row>
        <Col xs={12}>
          <PropertyMediaVideosWithStore />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <PropertyMediaImagesWithStore />
        </Col>
      </Row>
    </Container>
  );
};